import {
    useState
} from 'react';
import {
    CheckCircle2, HelpCircle
} from 'lucide-react';
import {
    Button
} from 'shared/components/ui/button';
import {
    Card
} from 'shared/components/ui/card';

export default function BexiQuestionCard({
    question, disabled, onAnswer, submitLabel = 'Continue'
}) {
    const multiple = question.mode === 'multiple';
    const [selected, setSelected] = useState([]);
    const [other, setOther] = useState('');

    const toggle = (value) => {
        setSelected((prev) => {
            if (!multiple) return [value];
            return prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value];
        });
    };

    const canSubmit = selected.length > 0 || other.trim();
    const submit = () => {
        if (!canSubmit || disabled) return;
        const chosen = (question.options || []).filter((opt) => selected.includes(opt.value));
        onAnswer({
            id: question.id,
            question: question.question,
            mode: question.mode,
            selected,
            chosen,
            other: other.trim() || undefined,
        });
    };

    return (
        <Card className="mt-2 border-sky-200 bg-sky-50 p-3 dark:bg-sky-950/30">
            <div className="flex items-start gap-2">
                <HelpCircle className="mt-0.5 h-4 w-4 shrink-0 text-sky-700 dark:text-sky-300" />
                <div className="min-w-0 flex-1">
                    <div className="text-sm font-semibold text-sky-900 dark:text-sky-100">{question.question}</div>
                    {question.detail && (
                        <div className="mt-2 whitespace-pre-wrap rounded-md border bg-background/80 p-2 text-xs leading-5 text-sky-950 dark:text-sky-50">
                            {question.detail}
                        </div>
                    )}
                    <div className="mt-2 space-y-1.5">
                        {(question.options || []).map((opt) => (
                            <label
                                key={opt.value}
                                className="flex cursor-pointer items-start gap-2 rounded-md border bg-background/80 px-2.5 py-2 text-sm hover:bg-background"
                            >
                                <input
                                    type={multiple ? 'checkbox' : 'radio'}
                                    name={question.id}
                                    checked={selected.includes(opt.value)}
                                    onChange={() => toggle(opt.value)}
                                    disabled={disabled}
                                    className="mt-1"
                                />
                                <span className="min-w-0">
                                    <span className="block font-medium">{opt.label}</span>
                                    {opt.description && (
                                        <span className="block text-xs text-muted-foreground">{opt.description}</span>
                                    )}
                                </span>
                            </label>
                        ))}
                    </div>
                    {question.allowOther && (
                        <textarea
                            value={other}
                            onChange={(e) => setOther(e.target.value)}
                            disabled={disabled}
                            rows={2}
                            placeholder="Other..."
                            className="mt-2 w-full resize-none rounded-md border bg-background px-2.5 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
                        />
                    )}
                    <Button size="sm" onClick={submit} disabled={!canSubmit || disabled} className="mt-2 gap-1">
                        <CheckCircle2 className="h-4 w-4" /> {submitLabel}
                    </Button>
                </div>
            </div>
        </Card>
    );
}
